import PropTypes from 'prop-types';
import Img from 'ui/imageWithFallback';
import {Container, Title, Points, NewBadge, MoreButton, Status} from './styles';

const pointsLabel = points => (Number(points) > 1 ? 'pts' : 'pt');

const ListItem = ({points, image, title, isNew, onOpen, openLabel, status}) => (
  <Container>
    {isNew && <NewBadge>Nouveau</NewBadge>}
    <Img src={image} />
    <Title
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{__html: title}}
    />
    {status && <Status>{status}</Status>}
    {!status && onOpen && (
      <MoreButton type="button" onClick={onOpen}>
        {openLabel}
      </MoreButton>
    )}
    <Points color="white" type="button" tabIndex={-1}>
      +{points} {pointsLabel(points)}
    </Points>
  </Container>
);

ListItem.propTypes = {
  points: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  isNew: PropTypes.bool,
  onOpen: PropTypes.func,
  openLabel: PropTypes.string,
  status: PropTypes.string,
};

ListItem.defaultProps = {
  isNew: false,
  onOpen: null,
  openLabel: 'En savoir plus',
  status: null,
};

export default ListItem;
